module.exports = __webpack_public_path__ + "img/users.2b4b29f6.svg";